"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ZipCodeForm = void 0;

var _react = _interopRequireWildcard(require("react"));

var _commonCta = require("@mmc/common-cta");

var _clsx = _interopRequireDefault(require("clsx"));

var _zipCodeForm = _interopRequireDefault(require("./zip-code-form.css"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ZipCodeForm = function ZipCodeForm(_ref) {
  var theme = _ref.theme,
      _ref$isSmallForm = _ref.isSmallForm,
      isSmallForm = _ref$isSmallForm === void 0 ? false : _ref$isSmallForm,
      onChange = _ref.onChange,
      zipCodeTitle = _ref.zipCodeTitle,
      zipCodePlaceHolder = _ref.zipCodePlaceHolder;

  var _useState = (0, _react.useState)(''),
      zipCode = _useState[0],
      setZipCode = _useState[1];

  var _useState2 = (0, _react.useState)(''),
      label = _useState2[0],
      setLabel = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      hideButton = _useState3[0],
      setHideButton = _useState3[1];

  var _useState4 = (0, _react.useState)(true),
      hideReset = _useState4[0],
      setHideReset = _useState4[1];

  var _useState5 = (0, _react.useState)({}),
      data = _useState5[0],
      setData = _useState5[1];

  var _useState6 = (0, _react.useState)(true),
      hideError = _useState6[0],
      serHideError = _useState6[1];

  var _useState7 = (0, _react.useState)(true),
      hideSuccess = _useState7[0],
      serHideSuccess = _useState7[1];

  (0, _react.useEffect)(function () {
    if (zipCodePlaceHolder) {
      setLabel(zipCodePlaceHolder);
    } else {
      setLabel('Postal Code');
    }
  }, []);

  var updateData = function updateData(value) {
    var dataUpdate = {
      value: value,
      isShowError: false,
      name: 'zipCode'
    };
    setData(dataUpdate);
  };

  var enterPress = function enterPress(e) {
    e.preventDefault();

    if (e.target.value.length === 5) {
      onChange(data);
      serHideSuccess(false);
      serHideError(true);
    } else {
      console.log('enterPress');
      serHideError(false);
      serHideSuccess(true);
    }
  };

  var getZipCode = function getZipCode() {
    serHideSuccess(false);
    serHideError(true);
    onChange(data);
  };

  var submitHandler = function submitHandler(e) {
    e.preventDefault();
  };

  var resetZipCode = function resetZipCode() {
    var dataReset = {
      value: '',
      isShowError: false,
      name: 'zipCode'
    };
    updateData('');
    setZipCode('');
    setHideReset(true);
    setHideButton(true);
    onChange(dataReset);
  };

  var onZipChange = function onZipChange(e) {
    serHideSuccess(true);
    serHideError(true);

    if (e.target.value.length > 5) {
      setZipCode(e.target.value.slice(0, 5));
      updateData(e.target.value);
    } else if (e.target.value.length === 5) {
      setHideButton(false);
      setZipCode(e.target.value);
      updateData(e.target.value);
    } else {
      setZipCode(e.target.value);
      setHideButton(true);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: isSmallForm ? _zipCodeForm["default"].zipCodeContainerSmallForm : _zipCodeForm["default"].zipCodeContainerForm
  }, /*#__PURE__*/_react["default"].createElement("form", {
    onSubmit: submitHandler,
    className: _zipCodeForm["default"].formZipCodeContainer + " " + (isSmallForm ? _zipCodeForm["default"].smallForm : ''),
    tabIndex: "-1"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: _zipCodeForm["default"].labelTitle
  }, zipCodeTitle), /*#__PURE__*/_react["default"].createElement("div", {
    className: _zipCodeForm["default"].inputContainer
  }, /*#__PURE__*/_react["default"].createElement("input", {
    id: "zip-code-input",
    className: _zipCodeForm["default"].searchInput,
    type: "number",
    pattern: "[0-9]",
    onChange: onZipChange,
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') enterPress(e);
    },
    value: zipCode,
    autoComplete: "false",
    tabIndex: "-1"
  }), /*#__PURE__*/_react["default"].createElement("label", {
    className: zipCode !== '' ? _zipCodeForm["default"].InputHasValue : _zipCodeForm["default"].searchInputLabel,
    htmlFor: "zip-code-form"
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: _zipCodeForm["default"].ctaContainer
  }, /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    tabIndex: "-1",
    clickEvent: resetZipCode,
    spanClasses: (0, _clsx["default"])(_zipCodeForm["default"].clearBtn, Boolean(hideReset) && _zipCodeForm["default"].hide),
    data: {
      priority: 'lowIcon',
      icon: 'Cross',
      ctaProps: {
        type: 'button'
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(_commonCta.CommonCta, {
    theme: theme,
    tabIndex: "-1",
    clickEvent: getZipCode,
    spanClasses: (0, _clsx["default"])(_zipCodeForm["default"].submitBtn, Boolean(hideButton) && _zipCodeForm["default"].hide),
    data: {
      priority: 'lowIcon',
      icon: 'Search',
      ctaProps: {
        type: 'button'
      }
    }
  }))), /*#__PURE__*/_react["default"].createElement("span", {
    className: _zipCodeForm["default"].labelTitle + " " + _zipCodeForm["default"].errorZipCodeMessage + " " + (hideError ? _zipCodeForm["default"].hideErrorMessage : '')
  }, "Please Enter a Valid Zip Code"), /*#__PURE__*/_react["default"].createElement("span", {
    className: _zipCodeForm["default"].labelTitle + " " + _zipCodeForm["default"].successZipCodeMessage + " " + (hideSuccess ? _zipCodeForm["default"].hideSuccessMessage : '')
  }, "Showing the Best Offers for This Region")));
};

exports.ZipCodeForm = ZipCodeForm;